import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { resolveSentryInitOptions } from './app/sentry/sentry-config';

const sentryOptions = resolveSentryInitOptions(environment);
if (sentryOptions.enabled) {
	Sentry.init(sentryOptions);
}

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => {
		console.error(err);
		if (sentryOptions.enabled) {
			Sentry.captureException(err);
		}
	});
